import React from "react";
import { useEffect, useRef, useState } from "react";
import {
  Box,
  Card,
  CardContent,
  Divider,
  makeStyles,
  Typography,
  Button,
  TextField,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  CircularProgress,
  Modal,
} from "@material-ui/core";
import { gpColors } from "../../../constants/colors";
import SideDrawer from "../Drawer";
import PlayBeepSound from "./PlayBeepSound";
import { Html5QrcodeScanner } from "html5-qrcode";
import { getCookie } from "../../../Functions";
import CryptoAES from "crypto-js/aes";
import CryptoENC from "crypto-js/enc-utf8";
import { set } from "lodash";
import { useLocation, useNavigate } from "react-router-dom";
import { routes } from "../../../constants/routes";
import DataTable from "react-data-table-component";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import Cookies from "js-cookie";
import api from "../../Interceptors/axiosInstance";

const useStyles = makeStyles((theme) => ({
  roots: {
    display: "flex",
    height: "auto",
    backgroundColor: "#EAE4E8",
  },
  content: {
    width: "100%",
    width: "100%",
    flexGrow: 1,
    paddingTop: "84px",
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    paddingBottom: theme.spacing(3),
  },
  title: {
    fontSize: "20px",
    fontWeight: 600,
    paddingBottom: 20,
  },
  root: {
    padding: "3%",
    minHeight: "280px",
    marginTop: "20px",
  },
  textFieldStyle: {
    width: "60%",
    height: "50px",
    [theme.breakpoints.only("sm")]: {
      width: "70%",
    },
    [theme.breakpoints.down("xs")]: {
      width: "100% !important",
    },
    "& .MuiOutlinedInput-root": {
      height: "50px",
    },
  },
  scanLocScanBoxRow: {
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      flexDirection: "column",
      gap: "350x",
      flexDirection: "column",
      gap: "350x",
    },
  },
  scanBox: {
    [theme.breakpoints.down("sm")]: {
      width: "100% !important",
    },
  },
  locScanTable: {
    [theme.breakpoints.down("sm")]: {
      width: "100% !important",
    },
  },
  scanButton: {
    backgroundColor: gpColors.logoBrown,
    color: "#fff !important",
    // width: "15%",
    "&.MuiButtonBase-root": {
      "&:hover": { backgroundColor: gpColors.logoBrown },
    },
    [theme.breakpoints.only("sm")]: {
      width: "45%",
    },
    [theme.breakpoints.down("xs")]: {
      width: "100%",
    },
  },
  qrBoxContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "left",
    alignItems: "left",
  },
  scanner: {
    width: "90%",
    marginTop: "5%",
    position: "unset !important",
    [theme.breakpoints.only("sm")]: {
      width: "100%",
    },
    [theme.breakpoints.down("xs")]: {
      width: "100%",
    },
  },
  exportButton: {
    backgroundColor: gpColors.logoBrown,
    color: "#fff",
    marginBottom: "12px",
    width: "15%",
    "&.MuiButtonBase-root": {
      "&:hover": { backgroundColor: gpColors.logoBrown },
    },
    [theme.breakpoints.down("sd")]: {
      width: "60%",
    },
  },
  editLink: {
    color: "rgb(23, 94, 170)",
    cursor: "pointer",
    textDecoration: "none",
    fontSize: "0.875rem",
    fontWeight: "bold",
    "&:hover": {
      textDecoration: "underline",
    },
  },
}));

export const InwardScan = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const [userData, setUserData] = useState({});
  const [upc, setUpc] = useState("");
  const [totalCBM, setTotalCBM] = useState(null);
  const [partData, setPartData] = useState([]);
  const [scanCount, setScanCount] = useState("");
  const [oldScanCount, setOldScanCount] = useState("");
  const [partNumber, setPartNumber] = useState("");


  const [locCbm, setLocCBM] = useState([]);
  const [loader, setLoader] = useState(false);
  const [token, setToken] = useState();
  const [btnLoader, setBtnLoader] = useState(false);
  const [alert, setAlert] = useState({
    alertStatus: false,
    alertMessage: "",
    alertColor: "",
  });
  const [showScanner, setShowScanner] = useState(false);

  const upcInputRef = useRef(null);
  const [disableUpcField, setDisableUpcField] = useState(true);
  const [disableScanBarcode, setDisableScanBarcode] = useState(true);
  const [scanText, setScanText] = useState("");
  const [openEdit, setOpenEdit] = useState(false);
  const [isEditDelete, setIsEditDelete] = useState(false);

  const html5QrcodeScannerRef = useRef(null);
  const qrcodeRegionId = "html5qr-code-full-region";

  const [locations, setLocations] = React.useState([]);
  const [disabledUPCField, setDisabledUPCField] = useState(true);
  const [selectedLocationId, setSelectedLocationId] = useState("");
  const handleLocationChange = (event) => {
    setSelectedLocationId(event.target.value);
    setDisableUpcField(event.target.value == 0 ? true : false);
    setDisableUpcField(event.target.value == 0 ? true : false);
  };
  useEffect(() => {
    if (selectedLocationId && upcInputRef.current) {
      upcInputRef.current.focus();
    }
  }, [selectedLocationId]);
  useEffect(() => {
    if (selectedLocationId && upcInputRef.current) {
      upcInputRef.current.focus();
    }
  }, [selectedLocationId]);

  const barcodeBtnClick = () => {
    if (selectedLocationId && upcInputRef.current) {
      upcInputRef.current.focus();
    }
  };
  // const getLoginInfoData = () => {
  //   const getValue = getCookie("guardPlus_user");
  //   if (getValue !== null) {
  //     const decryptedValue = CryptoAES.decrypt(getValue, "secretKey");
  //     const userVal = JSON.parse(decryptedValue.toString(CryptoENC));
  //     setUserData(userVal);
  //     setToken(userVal.loginInfo.data.jwt);
  //   }
  // };
  // const sessionUsername = Cookies.get("userName");
      const sessionUsername = sessionStorage.getItem("userName");

  const getLoginInfoData = () => {
    setUserData({ username: sessionUsername });
  };
  const [search, setSearch] = useState("");

  const filteredData = partData?.filter(
    (item) =>
      item.partNo?.toString().toLowerCase().includes(search.toLowerCase()) ||
      item.brandName?.toString().toLowerCase().includes(search.toLowerCase()) ||
      String(item.scans).includes(search) ||
      item.shipToLoc?.toString().toLowerCase().includes(search.toLowerCase()) ||
      String(item.cbm).includes(search)
  );

  const columns = [
    {
      name: "Part No",
      selector: (row) => (row.partNo ? row.partNo : "NA"),
      selector: (row) => (row.partNo ? row.partNo : "NA"),
      sortable: true,
      center: true,
    },
    {
      name: "Brand Name",
      selector: (row) => (row.brandName ? row.brandName : "NA"),
      selector: (row) => (row.brandName ? row.brandName : "NA"),
      sortable: true,
      center: true,
    },
     {
      name: "Ship to Location",
      selector: (row) => row.shipToLoc || "NA",
      sortable: true,
      center: true,
    },
    {
      name: "Scans",
      selector: (row) => row.availScans,
      sortable: true,
      center: true,
    },
    // {
    //   name: "Available Scans",
    //   selector: (row) => row.availScans,
    //   sortable: true,
    //   center: true,
    // },
    {
      name: "CBM",
      selector: (row) => row.availCbm,
      sortable: true,
      center: true,
    },
    {
      name: "Action",
      cell: (row) => (
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            alignItems: "center",
            gap: 10,
          }}
        >
          <span
            className={classes.editLink}
            onClick={() => handleEditModal(row)}
          >
            Edit
          </span>
        </Box>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      center: true,
    },
  ];
  const handleEditClose = () => setOpenEdit(false);
  const handleEditSave = async () => {
    handleEditClose();
    if (scanCount !== oldScanCount) {
      try {
        // const resp = await fetch(
        //   `${process.env.REACT_APP_API_ENDPOINT}/updateInwardScan`,
        //   {
        //     method: "POST",
        //     body: JSON.stringify({
        //       partNo: partNumber.trim(),
        //       scansCount: scanCount,
        //       emailId: userData.username,
        //       shipToLocId: selectedLocationId,

        //     }),
        //     headers: {
        //       // "ngrok-skip-browser-warning": "true",
        //       Authorization: `Token ${userData.loginInfo.data.jwt}`,
        //       "Content-Type": "application/json",
        //     },
        //   }
        // );
        const resp = await api.post("/updateInwardScan", {
          partNo: partNumber.trim(),
          scansCount: scanCount,
          emailId: userData.username,
          shipToLocId: selectedLocationId,
        });
        const data = await resp.data;
        if (data.result === "Success") {
          setAlert({
            ...alert,
            alertStatus: true,
            alertColor: "green",
            alertMessage: "Edited successfully",
          });
          setIsEditDelete(true);
        } else {
          setAlert({
            ...alert,
            alertStatus: true,
            alertColor: "red",
            alertMessage: "Something went wrong please try after sometime.",
          });
        }
      } catch (error) {
        console.log("updateContainerData error :--", error);
        setAlert({
          ...alert,
          alertStatus: true,
          alertColor: "red",
          alertMessage: "An error occurred while editing the data.",
        });
      }
    }
  };
  const handleNewScanCount = (e) => {
    if (e.target.value) {
      const newValue = parseInt(e.target.value);
      if (newValue < 0) {
        setScanCount(scanCount);
      } else {
        setScanCount(newValue);
      }
    }
  };
  const handleEditModal = (item) => {
    navigate(routes.UPDATE_INWARD_SCAN, { state: { partNo: item.partNo, locId: item.shipToLocId, outwardScan : false } });
    // setOpenEdit(true);
    setScanCount(item.scans);
    setOldScanCount(item.scans);
    setPartNumber(item.partNo);
    setSelectedLocationId(item.shipToLocId);
  };
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    getLoginInfoData();
  }, []);

  useEffect(() => {
    if (isEditDelete) {
      handleShowPartData();
      setIsEditDelete(false);
    }
  }, [isEditDelete]);
  useEffect(() => {
    if (isEditDelete) {
      handleShowPartData();
      setIsEditDelete(false);
    }
  }, [isEditDelete]);

  useEffect(() => {
    handleShowPartData();
  }, [userData]);

  const stopScanning = () => {
    setDisableUpcField(true);
    setUpc("");
    // setTotalCBM(null);
    setShowScanner(false);
    setScanText("");
    setSelectedLocationId("");
    setSelectedLocationId("");
    const stopButton = document.getElementById(
      "html5-qrcode-button-camera-stop"
    );
    if (stopButton) {
      stopButton.click();
    } else {
      console.error("Stop button not found in the DOM.");
    }
    setShowScanner(false);
  };

  useEffect(() => {
    if (showScanner) {
      const createConfig = () => ({
        fps: 10,
        qrbox: 250,
        disableFlip: false,
      });

      const config = createConfig();

      html5QrcodeScannerRef.current = new Html5QrcodeScanner(
        qrcodeRegionId,
        config
      );

      html5QrcodeScannerRef.current.render(
        (decodedText) => {
          // document.getElementById("result").innerText = decodedText;
          setScanText(decodedText);
          setUpc(decodedText);
        },
        (error) => {
          setAlert({
            alertStatus: true,
            alertMessage:
              "No MultiFormat Readers were able to detect the code.",
            alertColor: "red",
          }); // PlayBeepSound();
        }
      );
    }

    return () => {
      if (html5QrcodeScannerRef.current) {
        html5QrcodeScannerRef.current
          .clear()
          .catch((error) =>
            console.error("Failed to clear html5QrcodeScanner: ", error)
          );
      }
    };
  }, [showScanner]);
  useEffect(() => {
    if (scanText) {
      handleScanUpc(scanText);
      const stopButton = document.getElementById(
        "html5-qrcode-button-camera-stop"
      );
      if (stopButton) {
        stopButton.click();
      } else {
        console.error("Stop button not found in the DOM.");
      }
    }
  }, [scanText]);
  const handleUpcChange = (e) => {
    const newUPC = e.target.value;
    setUpc(newUPC);
  };

  useEffect(() => {
    const debounceHandler = setTimeout(() => {
      if (upc.trim()) {
        handleScanUpc(upc.trim());
      }
    }, 500); // 500ms debounce delay

    return () => {
      clearTimeout(debounceHandler);
    };
  }, [upc]);

  const handleScanUpc = async (newUPC) => {
    try {
      // const resp = await fetch(
      //   `${process.env.REACT_APP_API_ENDPOINT}/getPartNoAndSaveInwardData`,
      //   {
      //     method: "POST",
      //     body: JSON.stringify({
      //       upc: newUPC.trim(),
      //       emailId: userData.username,
      //       shipToLocId: selectedLocationId,
      //     }),
      //     headers: {
      //       // "ngrok-skip-browser-warning": "true",
      //       Authorization: `Token ${userData.loginInfo.data.jwt}`,
      //       "Content-Type": "application/json",
      //     },
      //   }
      // );
      const resp = await api.post("/getPartNoAndSaveInwardData", {
        upc: newUPC.trim(),
        emailId: userData.username,
        shipToLocId: selectedLocationId,
      });
      const data = await resp.data;
      if (data.result === "success" && data.partNo) {
        setTotalCBM(data.totalCBM);
        handleShowPartData();
      } else {
        setAlert({
          alertStatus: true,
          alertMessage:
            "Please enter a valid UPC or ensure the value is entered through scanning only.",
          alertColor: "red",
        });
        PlayBeepSound();
      }
      setUpc("");
      setScanText("");
    } catch (e) {
      console.log("getPartNoAndSaveContainerData Error :- ", e);
      setAlert({
        alertStatus: true,
        alertMessage: "Something went wrong please try after some time",
        alertColor: "red",
      });
      PlayBeepSound();
    }
  };

  const locHeadCells = [
    { id: "shipLoc", label: "Ship to Location" },
    { id: "cbm", label: "CBM" },
  ];

  const handleShowPartData = async () => {
    try {
      // const resp = await fetch(
      //   `${process.env.REACT_APP_API_ENDPOINT}/getInwardStockList`,
      //   {
      //     method: "GET",
      //     headers: {
      //       Authorization: `Token ${userData.loginInfo.data.jwt}`,
      //       "Content-Type": "application/json",
      //     },
      //   }
      // );
      const resp = await api.get("getInwardStockList");
      const data = resp.data;
      if (data.result === "success") {
        const resultData = data.resultData;
        const locData = data.locCbm;
        const locationsData = data.locations;
        if (Array.isArray(resultData) && resultData.length > 0) {
          setPartData(resultData);
        } else {
          setPartData([]);
        }
        setTotalCBM(data.totalCBM);
        setLocCBM(locData);
        setLocations(locationsData);
        setLoader(false);
      }
      setUpc("");
    } catch (e) {
      console.log("getInwardStockList Error :- ", e);
      setAlert({
        alertStatus: true,
        alertMessage: "Something went wrong please try after some time",
        alertColor: "red",
      });
    }
  };

  const exportStockList = async () => {
    setBtnLoader(true);
    try {
      // const response = await fetch(
      //   `${process.env.REACT_APP_API_ENDPOINT}/exportAllInwardStockList`,
      //   {
      //     method: "GET",
      //     headers: {
      //       // "ngrok-skip-browser-warning": "true",
      //       Authorization: `Token ${token}`,
      //     },
      //   }
      // );
      // const response = await api.get('exportAllInwardStockList')
      // if (response) {
      //   console.log('response: ', response)
      //   const blob = await response.data.data.blob();
      //   const url = window.URL.createObjectURL(blob);
      //   const a = document.createElement("a");
      //   a.href = url;
      //   const dateOnly = new Date().toISOString().split("T")[0];
      //   a.download = `InwardStockList_${dateOnly}.xlsx`;
      //   a.style.display = "none";
      //   document.body.appendChild(a);
      //   a.click();
      //   a.remove();
      //   window.URL.revokeObjectURL(url);
      // } else if (response.status === 404) {
      //   setAlert({
      //     ...alert,
      //     alertStatus: true,
      //     alertColor: "red",
      //     alertMessage: "No data found to generate Excel file.",
      //   });
      // } else {
      //   setAlert({
      //     ...alert,
      //     alertStatus: true,
      //     alertColor: "red",
      //     alertMessage: "An error occurred while exporting the data.",
      //   });
      // }
      const response = await api.get("exportAllInwardStockList", {
        responseType: "blob", 
      });

      if (response && response.status === 200) {
        const blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const url = window.URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = url;
        const dateOnly = new Date().toISOString().split("T")[0];
        a.download = `InwardStockList_${dateOnly}.xlsx`;
        a.style.display = "none";
        document.body.appendChild(a);
        a.click();
        a.remove();

        window.URL.revokeObjectURL(url);
      } else if (response.status === 404) {
        setAlert({
          ...alert,
          alertStatus: true,
          alertColor: "red",
          alertMessage: "No data found to generate Excel file.",
        });
      } else {
        setAlert({
          ...alert,
          alertStatus: true,
          alertColor: "red",
          alertMessage: "An error occurred while exporting the data.",
        });
      }
    } catch (error) {
      console.error("Error exporting containers:", error);
      setAlert({
        ...alert,
        alertStatus: true,
        alertColor: "red",
        alertMessage: "An error occurred while exporting the data.",
      });
    } finally {
      setBtnLoader(false);
    }
  };

  return (
    <Box className={classes.roots}>
      <SideDrawer tabName="scan" userData={userData} />
      <main className={classes.content}>
        <Box style={{ display: "flex", justifyContent: "space-between" }}>
          <Typography className={classes.title}>Inward Scan</Typography>
          <Button className={classes.exportButton} onClick={exportStockList}>
            {btnLoader ? <CircularProgress size={25} /> : "Export"}
          </Button>
        </Box>

        <Divider />
        <Card className={classes.root}>
          <CardContent mt={0}>
            {/* {totalCBM && ( */}
            <Box
              style={{
                display: "flex",
                flexDirection: "row",
                width: "100%",
                justifyContent: "flex-end",
                marginBottom: "20px",
              }}
            >
              <Typography style={{ fontSize: "20px", fontWeight: 600 }}>
                Total CBM - &nbsp;&nbsp; {totalCBM}
              </Typography>
            </Box>
            <Box
              className={classes.scanLocScanBoxRow}
              display={"flex"}
              flexDirection={"row"}
              gridGap={"2%"}
            >
              <Box className={classes.scanBox} style={{ width: "49%" }}>
                <Box
                  display="flex"
                  flexWrap="wrap"
                  gridGap={20}
                  alignItems="flex-start"
                  flexDirection="column"
                >
                  <FormControl
                    className={classes.textFieldStyle}
                    sx={{
                      m: 0,
                      minWidth: 120,
                      width: "60%",
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          borderColor: "#cfd1cf",
                        },
                        "&:hover fieldset": {
                          borderColor: "#cfd1cf",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: "#cfd1cf",
                        },
                      },
                      "& label.Mui-focused": {
                        color: "black",
                      },
                    }}
                  >
                    <InputLabel
                      id="demo-simple-select-required-label"
                      className={classes.textFieldStyle}
                    >
                      {" "}
                      Select Location{" "}
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-required-label"
                      id="demo-simple-select-required"
                      value={selectedLocationId}
                      label="Select Location"
                      onChange={handleLocationChange}
                      sx={{ height: "50%" }}
                    >
                      {locations && locations.length > 0 ? (
                        locations.map((location) => (
                          <MenuItem key={location.id} value={location.id}>
                            {location.location}
                          </MenuItem>
                        ))
                      ) : (
                        <MenuItem value={0} disabled>
                          No Items
                        </MenuItem>
                      )}
                    </Select>
                  </FormControl>
                  <TextField
                    variant="outlined"
                    size="small"
                    className={classes.textFieldStyle}
                    placeholder="Scan UPC"
                    value={upc}
                    onChange={handleUpcChange}
                    // onBlur={handleUpcChange}
                    inputRef={upcInputRef}
                    disabled={disableUpcField}
                  />
                </Box>
                <Box display="flex" justifyContent="left" mt={3}>
                  <Typography
                    style={{
                      fontSize: "1.1rem",
                      fontWeight: "bold",
                      color: "red",
                      textTransform: "capitalize",
                    }}
                  >
                    OR
                  </Typography>
                </Box>

                <Box
                  display="flex"
                  flexWrap="wrap"
                  gridGap={20}
                  alignItems="center"
                  mt={3}
                >
                  <Button
                    className={classes.scanButton}
                    onClick={() => {
                      setShowScanner(true);
                      barcodeBtnClick();
                    }}
                    disabled={disableUpcField}
                  >
                    Scan Barcode
                  </Button>
                </Box>

                {showScanner && (
                  <Box>
                    <Box className={classes.qrBoxContainer}>
                      <div id={qrcodeRegionId} className={classes.scanner} />
                    </Box>
                    {/* <Typography id="result" variant="body1" color="textSecondary" /> */}
                    {/* <br /> */}
                    <Typography>{scanText}</Typography>
                  </Box>
                )}

                <Box mt={5}>
                  <Button className={classes.scanButton} onClick={stopScanning}>
                    Stop Scan
                  </Button>
                </Box>
              </Box>
              <Box className={classes.locScanTable} style={{ width: "49%" }}>
                <TableContainer style={{ maxHeight: 300, overflowY: "auto" }}>
                  <Table
                    style={{ borderRadius: "20px" }}
                    stickyHeader
                    aria-labelledby="tableTitle"
                  >
                    <TableHead>
                      <TableRow>
                        {locHeadCells.map((headCell) => (
                          <TableCell
                            align="center"
                            style={{
                              backgroundColor: gpColors.logoGray,
                              color: "#fff",
                              fontWeight: "bold",
                            }}
                            key={headCell.id}
                          >
                            {headCell.label}
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {loader ? (
                        <TableRow>
                          <TableCell
                            colSpan={locHeadCells.length}
                            align="center"
                          >
                            <CircularProgress color="inherit" size={25} />
                          </TableCell>
                        </TableRow>
                      ) : locCbm && locCbm.length > 0 ? (
                        locCbm.map((item, index) => (
                          <TableRow
                            key={item.id}
                            style={{
                              backgroundColor:
                                index % 2 === 0 ? "#fff" : "#fafafa",
                            }}
                          >
                            <TableCell
                              align="center"
                              style={{ fontSize: "0.875rem" }}
                            >
                              {item.shipToLoc}
                            </TableCell>
                            <TableCell
                              align="center"
                              style={{ fontSize: "0.875rem" }}
                            >
                              {item.totalCbm}
                            </TableCell>
                          </TableRow>
                        ))
                      ) : (
                        <TableRow>
                          <TableCell
                            colSpan={locHeadCells.length}
                            align="center"
                            style={{ color: "red" }}
                          >
                            Data Not Exist
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </Box>
            {/* stock list  */}
            <Box mt={4}>
              <Typography
                style={{
                  fontSize: "22px",
                  fontWeight: 600,
                  marginBottom: "10px",
                }}
              >
                Stock List:
              </Typography>
              <div style={{ padding: "20px" }}>
                <Box
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "flex-end",
                    alignItems: "center",
                  }}
                >
                  {/* Search Bar */}
                  <input
                    type="text"
                    placeholder="Search..."
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    style={{
                      marginBottom: "10px",
                      padding: "10px",
                      width: "300px",
                      border: "1px solid #ccc",
                      borderRadius: "4px",
                    }}
                  />
                </Box>
                {/* Data Table */}
                <Box sx={{ borderRadius: 2, overflow: "hidden" }}>
                  <DataTable
                    columns={columns}
                    data={filteredData || []}
                    progressPending={loader}
                    progressComponent={
                      <CircularProgress size={30} color="inherit" />
                    }
                    noDataComponent={
                      <div style={{ color: "red" }}>Data Not Exist</div>
                    }
                    pagination
                    paginationPerPage={10}
                    paginationRowsPerPageOptions={[5, 10, 20, 50, 100]}
                    highlightOnHover
                    striped
                    responsive
                    persistTableHead
                    customStyles={{
                      headCells: {
                        style: {
                          backgroundColor: gpColors.logoGray,
                          color: "#fff",
                          fontWeight: "bold",
                          justifyContent: "center",
                        },
                      },
                      rows: {
                        style: {
                          fontSize: "0.875rem",
                        },
                      },
                    }}
                  />
                </Box>
              </div>
            </Box>
          </CardContent>
        </Card>
        {/* Edit Modal */}
        <Modal
          open={openEdit}
          onClose={handleEditClose}
          aria-labelledby="modal-title"
          aria-describedby="modal-description"
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: 400,
              bgcolor: "background.paper",
              borderRadius: 10,
              boxShadow: 24,
              p: 4,
            }}
          >
             <Box sx={{ borderRadius: 2, overflow: "hidden" }}>
                  <DataTable
                    columns={columns}
                    data={filteredData || []}
                    progressPending={loader}
                    progressComponent={
                      <CircularProgress size={30} color="inherit" />
                    }
                    noDataComponent={
                      <div style={{ color: "red" }}>Data Not Exist</div>
                    }
                    pagination
                    paginationPerPage={10}
                    paginationRowsPerPageOptions={[5, 10, 20, 50, 100]}
                    highlightOnHover
                    striped
                    responsive
                    persistTableHead
                    customStyles={{
                      headCells: {
                        style: {
                          backgroundColor: gpColors.logoGray,
                          color: "#fff",
                          fontWeight: "bold",
                          justifyContent: "center",
                        },
                      },
                      rows: {
                        style: {
                          fontSize: "0.875rem",
                        },
                      },
                    }}
                  />
                </Box>
            {/* <Box sx={{ display: "flex", flexDirection: "column" }}>
              <Typography
                id="modal-description"
                variant="body1"
                style={{ textAlign: "left" }}
              >
                No. of Boxes
              </Typography>
              <TextField
                className={classes.input}
                variant="outlined"
                value={scanCount}
                onChange={handleNewScanCount}
                type="number"
                inputProps={{ min: 0 }}
              />
            </Box>
            <Box display="flex" justifyContent="center" mt={4}>
              <Button
                onClick={handleEditSave}
                style={{
                  backgroundColor: "#F22F46",
                  color: "#fff",
                  width: "70%",
                }}
              >
                Update
              </Button>
            </Box> */}
          </Box>
        </Modal>
      </main>
    </Box>
  );
};
